export default __webpack_public_path__ + "static/media/taps-head-global-js.235fb995.jpg";